/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';

import { withPushFiltersToUrl } from '../../common/decorators';
import { SelectRole } from '../../../common/SelectRole';
import SearchBar from '../../common/SearchBar';
import DownloadCSVButton from '../../common/downloadCSVButton';
import { SERVER_URL } from '../../../../config';
import RefreshButton from '../../../common/refreshbutton';
import Tooltip from '../../../common/Tooltip';
import history from '../../../../history';

@withPushFiltersToUrl
export default class SubscriptionTable extends Component {
    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <div className="subscriptions-table table-container">
                <div className="table-filter-container">
                    <SelectRole
                        onFilterChange={this.props.onFilterChange}
                        currentUrlParams={currentUrlParams}
                    />
                    <SearchBar
                        filterKey="search"
                        onFilterChange={this.props.onFilterChange}
                        currentUrlParams={currentUrlParams}
                    />
                    <div className="table-action-bar">
                        <RefreshButton reloadData={this.props.onFetchData} />
                        <div className="grouped-buttons">
                            <DownloadCSVButton
                                endpoint="jobs"
                                params={{ type: 'subscription' }}
                            />
                        </div>
                    </div>
                </div>
                <ReactTable
                    page={this.props.currentPage}
                    pageSize={0}
                    data={this.props.data}
                    pages={this.props.pages}
                    columns={this.columns}
                    showPaginationBottom={this.props.showPaginationBottom}
                    className="shifts table-content"
                    loading={this.props.loading}
                    showPageSizeOptions={false}
                    manual={true}
                    // eslint-disable-next-line no-return-assign, no-sequences
                    ref={table => (
                        // eslint-disable-next-line no-sequences
                        (this.table = table), this.props.setTable(table)
                    )}
                    onFetchData={this.props.onFetchData}
                    onPageChange={this.props.onPageChange}
                    onSortedChange={this.props.onSortedChange}
                />
            </div>
        );
    }

    columns = [
        {
            Header: '',
            accessor: 'Checkbox',
            sortable: false,
            headerClassName: 'xsmall-col',
            className: 'xsmall-col',
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            Cell: () => {},
        },
        {
            Header: 'Ref',
            accessor: 'reference_number',
            id: 'reference_number',
            sortable: false,
            Cell: row => {
                if (
                    (this.props.user.isAgent && !row.original.owned) ||
                    (this.props.user.isAgent && !row.original.managed)
                ) {
                    let tooltipMessage;
                    if (row.original.owned && !row.original.managed) {
                        tooltipMessage = `This job is managed by ${row.original.managing_agency_details.company_name}`;
                    } else {
                        tooltipMessage = `This job is delegated by ${row.original.owner_agency_details.company_name}`;
                    }
                    return (
                        <a href={`${SERVER_URL}/job/${row.original.id}`}>
                            {row.value}
                            <Tooltip tooltip={<span>{tooltipMessage}</span>}>
                                <i className="icon icon-infomation-circle margin-5-px" />
                            </Tooltip>
                        </a>
                    );
                }
                return (
                    <a href={`${SERVER_URL}/job/${row.original.id}`}>
                        {row.value}
                    </a>
                );
            },
        },
        {
            Header: 'Day',
            accessor: 'start_datetime',
            Cell: row => <span>Every {moment(row.value).format('dddd')}</span>,
        },
        {
            Header: 'Start',
            accessor: 'start_datetime',
            headerClassName: 'small-col',
            className: 'small-col',
            Cell: row => moment(row.value).format('HH:mm'),
        },
        {
            Header: 'Hours',
            accessor: 'duration',
            headerClassName: 'xsmall-col',
            className: 'xsmall-col',
        },
        {
            Header: 'Service',
            accessor: 'service_role',
        },
        {
            Header: 'Num. workers',
            accessor: 'number_of_freelancers',
        },
        {
            Header: 'Location',
            accessor: 'postcode',
            headerClassName: 'small-col',
            className: 'small-col',
        },
        {
            Header: 'Next occurrence',
            accessor: 'next_date',
            Cell: row => moment(row.value).format('DD/MM/YYYY'),
        },
    ];
}
